// store/Automation/action.js

import {
  AUTOMATION_SCENARIO_LIST,
  AUTOMATION_SCENARIO_LIST_SUCCESS,
  AUTOMATION_SCENARIO_LIST_FAILURE,
  AUTOMATION_SCENARIO_STATUS_LIST,
  AUTOMATION_SCENARIO_STATUS_LIST_SUCCESS,
  AUTOMATION_SCENARIO_STATUS_LIST_FAILURE,
  AUTOMATION_CANVAS,
  AUTOMATION_CANVAS_SUCCESS,
  AUTOMATION_CANVAS_FAILURE,
  AUTOMATION_SCENARIO_CREATE,
  AUTOMATION_SCENARIO_CREATE_SUCCESS,
  AUTOMATION_SCENARIO_CREATE_FAILURE,
  AUTOMATION_SCENARIO_UPDATE,
  AUTOMATION_SCENARIO_UPDATE_SUCCESS,
  AUTOMATION_SCENARIO_UPDATE_FAILURE,
  AUTOMATION_SCENARIO_PUBLISH,
  AUTOMATION_SCENARIO_PUBLISH_SUCCESS,
  AUTOMATION_SCENARIO_PUBLISH_FAILURE,
  AUTOMATION_SCENARIO_DUPLICATE,
  AUTOMATION_SCENARIO_DUPLICATE_SUCCESS,
  AUTOMATION_SCENARIO_DUPLICATE_FAILURE,
  AUTOMATION_SCENARIO_DISABLE,
  AUTOMATION_SCENARIO_DISABLE_SUCCESS,
  AUTOMATION_SCENARIO_DISABLE_FAILURE,
  AUTOMATION_SCENARIO_DELETE,
  AUTOMATION_SCENARIO_DELETE_SUCCESS,
  AUTOMATION_SCENARIO_DELETE_FAILURE,
  AUTOMATION_NODE_CREATE,
  AUTOMATION_NODE_CREATE_SUCCESS,
  AUTOMATION_NODE_CREATE_FAILURE,
  AUTOMATION_NODE_UPDATE,
  AUTOMATION_NODE_UPDATE_SUCCESS,
  AUTOMATION_NODE_UPDATE_FAILURE,
  AUTOMATION_NODE_DELETE,
  AUTOMATION_NODE_DELETE_SUCCESS,
  AUTOMATION_NODE_DELETE_FAILURE,
  AUTOMATION_LINK_CREATE,
  AUTOMATION_LINK_CREATE_SUCCESS,
  AUTOMATION_LINK_CREATE_FAILURE,
  AUTOMATION_LINK_DELETE,
  AUTOMATION_LINK_DELETE_SUCCESS,
  AUTOMATION_LINK_DELETE_FAILURE,
  AUTOMATION_BLOCK_CONFIG_FIELDS,
  AUTOMATION_BLOCK_CONFIG_FIELDS_SUCCESS,
  AUTOMATION_BLOCK_CONFIG_FIELDS_FAILURE,
  AUTOMATION_NODE_CONFIG_SAVE,
  AUTOMATION_NODE_CONFIG_SAVE_SUCCESS,
  AUTOMATION_NODE_CONFIG_SAVE_FAILURE,
  AUTOMATION_NODE_CONFIG_DELETE,
  AUTOMATION_NODE_CONFIG_DELETE_SUCCESS,
  AUTOMATION_NODE_CONFIG_DELETE_FAILURE,
  AUTOMATION_DELAY_CREATE,
  AUTOMATION_DELAY_CREATE_SUCCESS,
  AUTOMATION_DELAY_CREATE_FAILURE,
  AUTOMATION_DELAY_UPDATE,
  AUTOMATION_DELAY_UPDATE_SUCCESS,
  AUTOMATION_DELAY_UPDATE_FAILURE,
  AUTOMATION_CONDITION_GROUP_CREATE,
  AUTOMATION_CONDITION_GROUP_CREATE_SUCCESS,
  AUTOMATION_CONDITION_GROUP_CREATE_FAILURE,
  AUTOMATION_CONDITION_GROUP_UPDATE,
  AUTOMATION_CONDITION_GROUP_UPDATE_SUCCESS,
  AUTOMATION_CONDITION_GROUP_UPDATE_FAILURE,
  AUTOMATION_CONDITION_GROUP_DELETE,
  AUTOMATION_CONDITION_GROUP_DELETE_SUCCESS,
  AUTOMATION_CONDITION_GROUP_DELETE_FAILURE,
  AUTOMATION_CONDITION_RULE_CREATE,
  AUTOMATION_CONDITION_RULE_CREATE_SUCCESS,
  AUTOMATION_CONDITION_RULE_CREATE_FAILURE,
  AUTOMATION_CONDITION_RULE_UPDATE,
  AUTOMATION_CONDITION_RULE_UPDATE_SUCCESS,
  AUTOMATION_CONDITION_RULE_UPDATE_FAILURE,
  AUTOMATION_CONDITION_RULE_DELETE,
  AUTOMATION_CONDITION_RULE_DELETE_SUCCESS,
  AUTOMATION_CONDITION_RULE_DELETE_FAILURE,
  AUTOMATION_EXECUTION_LIST,
  AUTOMATION_EXECUTION_LIST_SUCCESS,
  AUTOMATION_EXECUTION_LIST_FAILURE,
  AUTOMATION_EXECUTION_DATA,
  AUTOMATION_EXECUTION_DATA_SUCCESS,
  AUTOMATION_EXECUTION_DATA_FAILURE,
  AUTOMATION_EXECUTION_TRIGGER,
  AUTOMATION_EXECUTION_TRIGGER_SUCCESS,
  AUTOMATION_EXECUTION_TRIGGER_FAILURE,
  AUTOMATION_EXECUTION_STATUS_LIST,
  AUTOMATION_EXECUTION_STATUS_LIST_SUCCESS,
  AUTOMATION_EXECUTION_STATUS_LIST_FAILURE,
} from "./actionType";

//AUTOMATION_SCENARIO_LIST
export const automationScenarioList = () => ({ type: AUTOMATION_SCENARIO_LIST });
export const automationScenarioListSuccess = (payload) => ({ type: AUTOMATION_SCENARIO_LIST_SUCCESS, payload });
export const automationScenarioListFailure = (payload) => ({ type: AUTOMATION_SCENARIO_LIST_FAILURE, payload });

//AUTOMATION_SCENARIO_STATUS_LIST
export const automationScenarioStatusList = () => ({ type: AUTOMATION_SCENARIO_STATUS_LIST });
export const automationScenarioStatusListSuccess = (payload) => ({ type: AUTOMATION_SCENARIO_STATUS_LIST_SUCCESS, payload });
export const automationScenarioStatusListFailure = (payload) => ({ type: AUTOMATION_SCENARIO_STATUS_LIST_FAILURE, payload });

//AUTOMATION_CANVAS
export const automationCanvas = (payload) => ({ type: AUTOMATION_CANVAS, payload });
export const automationCanvasSuccess = (payload) => ({ type: AUTOMATION_CANVAS_SUCCESS, payload });
export const automationCanvasFailure = (payload) => ({ type: AUTOMATION_CANVAS_FAILURE, payload });

//AUTOMATION_SCENARIO_CREATE
export const automationScenarioCreate = (payload) => ({ type: AUTOMATION_SCENARIO_CREATE, payload });
export const automationScenarioCreateSuccess = (payload) => ({ type: AUTOMATION_SCENARIO_CREATE_SUCCESS, payload });
export const automationScenarioCreateFailure = (payload) => ({ type: AUTOMATION_SCENARIO_CREATE_FAILURE, payload });

//AUTOMATION_SCENARIO_UPDATE
export const automationScenarioUpdate = (payload) => ({ type: AUTOMATION_SCENARIO_UPDATE, payload });
export const automationScenarioUpdateSuccess = (payload) => ({ type: AUTOMATION_SCENARIO_UPDATE_SUCCESS, payload });
export const automationScenarioUpdateFailure = (payload) => ({ type: AUTOMATION_SCENARIO_UPDATE_FAILURE, payload });

//AUTOMATION_SCENARIO_PUBLISH
export const automationScenarioPublish = (payload) => ({ type: AUTOMATION_SCENARIO_PUBLISH, payload });
export const automationScenarioPublishSuccess = (payload) => ({ type: AUTOMATION_SCENARIO_PUBLISH_SUCCESS, payload });
export const automationScenarioPublishFailure = (payload) => ({ type: AUTOMATION_SCENARIO_PUBLISH_FAILURE, payload });

//AUTOMATION_SCENARIO_DUPLICATE
export const automationScenarioDuplicate = (payload) => ({ type: AUTOMATION_SCENARIO_DUPLICATE, payload });
export const automationScenarioDuplicateSuccess = (payload) => ({ type: AUTOMATION_SCENARIO_DUPLICATE_SUCCESS, payload });
export const automationScenarioDuplicateFailure = (payload) => ({ type: AUTOMATION_SCENARIO_DUPLICATE_FAILURE, payload });

//AUTOMATION_SCENARIO_DISABLE
export const automationScenarioDisable = (payload) => ({ type: AUTOMATION_SCENARIO_DISABLE, payload });
export const automationScenarioDisableSuccess = (payload) => ({ type: AUTOMATION_SCENARIO_DISABLE_SUCCESS, payload });
export const automationScenarioDisableFailure = (payload) => ({ type: AUTOMATION_SCENARIO_DISABLE_FAILURE, payload });

//AUTOMATION_SCENARIO_DELETE
export const automationScenarioDelete = (payload) => ({ type: AUTOMATION_SCENARIO_DELETE, payload });
export const automationScenarioDeleteSuccess = (payload) => ({ type: AUTOMATION_SCENARIO_DELETE_SUCCESS, payload });
export const automationScenarioDeleteFailure = (payload) => ({ type: AUTOMATION_SCENARIO_DELETE_FAILURE, payload });

//AUTOMATION_NODE_CREATE
export const automationNodeCreate = (payload) => ({ type: AUTOMATION_NODE_CREATE, payload });
export const automationNodeCreateSuccess = (payload) => ({ type: AUTOMATION_NODE_CREATE_SUCCESS, payload });
export const automationNodeCreateFailure = (payload) => ({ type: AUTOMATION_NODE_CREATE_FAILURE, payload });

//AUTOMATION_NODE_UPDATE
export const automationNodeUpdate = (payload) => ({ type: AUTOMATION_NODE_UPDATE, payload });
export const automationNodeUpdateSuccess = (payload) => ({ type: AUTOMATION_NODE_UPDATE_SUCCESS, payload });
export const automationNodeUpdateFailure = (payload) => ({ type: AUTOMATION_NODE_UPDATE_FAILURE, payload });

//AUTOMATION_NODE_DELETE
export const automationNodeDelete = (payload) => ({ type: AUTOMATION_NODE_DELETE, payload });
export const automationNodeDeleteSuccess = (payload) => ({ type: AUTOMATION_NODE_DELETE_SUCCESS, payload });
export const automationNodeDeleteFailure = (payload) => ({ type: AUTOMATION_NODE_DELETE_FAILURE, payload });

//AUTOMATION_LINK_CREATE
export const automationLinkCreate = (payload) => ({ type: AUTOMATION_LINK_CREATE, payload });
export const automationLinkCreateSuccess = (payload) => ({ type: AUTOMATION_LINK_CREATE_SUCCESS, payload });
export const automationLinkCreateFailure = (payload) => ({ type: AUTOMATION_LINK_CREATE_FAILURE, payload });

//AUTOMATION_LINK_DELETE
export const automationLinkDelete = (payload) => ({ type: AUTOMATION_LINK_DELETE, payload });
export const automationLinkDeleteSuccess = (payload) => ({ type: AUTOMATION_LINK_DELETE_SUCCESS, payload });
export const automationLinkDeleteFailure = (payload) => ({ type: AUTOMATION_LINK_DELETE_FAILURE, payload });

//AUTOMATION_BLOCK_CONFIG_FIELDS
export const automationBlockConfigFields = (payload) => ({ type: AUTOMATION_BLOCK_CONFIG_FIELDS, payload });
export const automationBlockConfigFieldsSuccess = (payload) => ({ type: AUTOMATION_BLOCK_CONFIG_FIELDS_SUCCESS, payload });
export const automationBlockConfigFieldsFailure = (payload) => ({ type: AUTOMATION_BLOCK_CONFIG_FIELDS_FAILURE, payload });

//AUTOMATION_NODE_CONFIG_SAVE
export const automationNodeConfigSave = (payload) => ({ type: AUTOMATION_NODE_CONFIG_SAVE, payload });
export const automationNodeConfigSaveSuccess = (payload) => ({ type: AUTOMATION_NODE_CONFIG_SAVE_SUCCESS, payload });
export const automationNodeConfigSaveFailure = (payload) => ({ type: AUTOMATION_NODE_CONFIG_SAVE_FAILURE, payload });

//AUTOMATION_NODE_CONFIG_DELETE
export const automationNodeConfigDelete = (payload) => ({ type: AUTOMATION_NODE_CONFIG_DELETE, payload });
export const automationNodeConfigDeleteSuccess = (payload) => ({ type: AUTOMATION_NODE_CONFIG_DELETE_SUCCESS, payload });
export const automationNodeConfigDeleteFailure = (payload) => ({ type: AUTOMATION_NODE_CONFIG_DELETE_FAILURE, payload });

//AUTOMATION_DELAY_CREATE
export const automationDelayCreate = (payload) => ({ type: AUTOMATION_DELAY_CREATE, payload });
export const automationDelayCreateSuccess = (payload) => ({ type: AUTOMATION_DELAY_CREATE_SUCCESS, payload });
export const automationDelayCreateFailure = (payload) => ({ type: AUTOMATION_DELAY_CREATE_FAILURE, payload });

//AUTOMATION_DELAY_UPDATE
export const automationDelayUpdate = (payload) => ({ type: AUTOMATION_DELAY_UPDATE, payload });
export const automationDelayUpdateSuccess = (payload) => ({ type: AUTOMATION_DELAY_UPDATE_SUCCESS, payload });
export const automationDelayUpdateFailure = (payload) => ({ type: AUTOMATION_DELAY_UPDATE_FAILURE, payload });

//AUTOMATION_CONDITION_GROUP_CREATE
export const automationConditionGroupCreate = (payload) => ({ type: AUTOMATION_CONDITION_GROUP_CREATE, payload });
export const automationConditionGroupCreateSuccess = (payload) => ({ type: AUTOMATION_CONDITION_GROUP_CREATE_SUCCESS, payload });
export const automationConditionGroupCreateFailure = (payload) => ({ type: AUTOMATION_CONDITION_GROUP_CREATE_FAILURE, payload });

//AUTOMATION_CONDITION_GROUP_UPDATE
export const automationConditionGroupUpdate = (payload) => ({ type: AUTOMATION_CONDITION_GROUP_UPDATE, payload });
export const automationConditionGroupUpdateSuccess = (payload) => ({ type: AUTOMATION_CONDITION_GROUP_UPDATE_SUCCESS, payload });
export const automationConditionGroupUpdateFailure = (payload) => ({ type: AUTOMATION_CONDITION_GROUP_UPDATE_FAILURE, payload });

//AUTOMATION_CONDITION_GROUP_DELETE
export const automationConditionGroupDelete = (payload) => ({ type: AUTOMATION_CONDITION_GROUP_DELETE, payload });
export const automationConditionGroupDeleteSuccess = (payload) => ({ type: AUTOMATION_CONDITION_GROUP_DELETE_SUCCESS, payload });
export const automationConditionGroupDeleteFailure = (payload) => ({ type: AUTOMATION_CONDITION_GROUP_DELETE_FAILURE, payload });

//AUTOMATION_CONDITION_RULE_CREATE
export const automationConditionRuleCreate = (payload) => ({ type: AUTOMATION_CONDITION_RULE_CREATE, payload });
export const automationConditionRuleCreateSuccess = (payload) => ({ type: AUTOMATION_CONDITION_RULE_CREATE_SUCCESS, payload });
export const automationConditionRuleCreateFailure = (payload) => ({ type: AUTOMATION_CONDITION_RULE_CREATE_FAILURE, payload });

//AUTOMATION_CONDITION_RULE_UPDATE
export const automationConditionRuleUpdate = (payload) => ({ type: AUTOMATION_CONDITION_RULE_UPDATE, payload });
export const automationConditionRuleUpdateSuccess = (payload) => ({ type: AUTOMATION_CONDITION_RULE_UPDATE_SUCCESS, payload });
export const automationConditionRuleUpdateFailure = (payload) => ({ type: AUTOMATION_CONDITION_RULE_UPDATE_FAILURE, payload });

//AUTOMATION_CONDITION_RULE_DELETE
export const automationConditionRuleDelete = (payload) => ({ type: AUTOMATION_CONDITION_RULE_DELETE, payload });
export const automationConditionRuleDeleteSuccess = (payload) => ({ type: AUTOMATION_CONDITION_RULE_DELETE_SUCCESS, payload });
export const automationConditionRuleDeleteFailure = (payload) => ({ type: AUTOMATION_CONDITION_RULE_DELETE_FAILURE, payload });

//AUTOMATION_EXECUTION_LIST
export const automationExecutionList = (payload) => ({ type: AUTOMATION_EXECUTION_LIST, payload });
export const automationExecutionListSuccess = (payload) => ({ type: AUTOMATION_EXECUTION_LIST_SUCCESS, payload });
export const automationExecutionListFailure = (payload) => ({ type: AUTOMATION_EXECUTION_LIST_FAILURE, payload });

//AUTOMATION_EXECUTION_DATA
export const automationExecutionData = (payload) => ({ type: AUTOMATION_EXECUTION_DATA, payload });
export const automationExecutionDataSuccess = (payload) => ({ type: AUTOMATION_EXECUTION_DATA_SUCCESS, payload });
export const automationExecutionDataFailure = (payload) => ({ type: AUTOMATION_EXECUTION_DATA_FAILURE, payload });

//AUTOMATION_EXECUTION_TRIGGER
export const automationExecutionTrigger = (payload) => ({ type: AUTOMATION_EXECUTION_TRIGGER, payload });
export const automationExecutionTriggerSuccess = (payload) => ({ type: AUTOMATION_EXECUTION_TRIGGER_SUCCESS, payload });
export const automationExecutionTriggerFailure = (payload) => ({ type: AUTOMATION_EXECUTION_TRIGGER_FAILURE, payload });

//AUTOMATION_EXECUTION_STATUS_LIST
export const automationExecutionStatusList = () => ({ type: AUTOMATION_EXECUTION_STATUS_LIST });
export const automationExecutionStatusListSuccess = (payload) => ({ type: AUTOMATION_EXECUTION_STATUS_LIST_SUCCESS, payload });
export const automationExecutionStatusListFailure = (payload) => ({ type: AUTOMATION_EXECUTION_STATUS_LIST_FAILURE, payload });
